import { useEffect, useState } from 'react';
import {
  getIntegerParamFromLocationSearch,
  setPagePart,
} from '../../utils/navigation';
import { useHistory } from 'react-router-dom';

export const useParts = ({
  maxParts,
  onComplete,
  resetOnMount,
}: {
  maxParts: number;
  onComplete?: () => void;
  resetOnMount?: boolean;
}) => {
  const history = useHistory();
  const urlPart =
    getIntegerParamFromLocationSearch(history.location.search, 'part') || 1;
  const [part, setPart] = useState(urlPart);

  useEffect(() => {
    if (!resetOnMount) return;
    setPagePart(history, history.location, 1);
  }, [resetOnMount, history]);

  useEffect(() => {
    setPart(urlPart);
  }, [urlPart]);
  const onNext = () => {
    if (part + 1 <= maxParts) {
      setPagePart(history, history.location, part + 1);
    } else if (onComplete) {
      onComplete();
    }
  };
  return {
    part,
    onNext,
  };
};
